@for (alert of alerts; track alert) {
  <div [ngClass]="cssClass(alert)" class="containerAlert">
    <span [innerHTML]="alert.message" role="alert" aria-live="assertive">
    </span>
  </div>
}